import OneSignal from 'react-onesignal';

// const IDApp = "278d2237-4565-4cf2-be67-3b50c4c63a55"
// Android
const IDApp = "2a3f54c7-071e-43a2-bed6-7ad8248de675" 
// IOS
const IDAppIos = "8f88555d-cf59-4564-afb3-bba80e473ccc"


const ANDROID_APP_ID = "2a3f54c7-071e-43a2-bed6-7ad8248de675";
const IOS_APP_ID = "8f88555d-cf59-4564-afb3-bba80e473ccc";

// const Key ="os_v2_app_e6gsen2fmvgpfpthhnimjrr2kvxn2c7vgnwul6egq6bcfgc5sguigodgjorbyqwvmqxule2qerk4dkbvkwooot4k6bpbdz7sr43ozsy"

// Original
const KeyIos ="os_v2_app_r6efkxoplfcwjl5txoua4rz4ztc772qsvl2eqruhbpyohaokarhaw65r6jlok5az5vis7lju6abvkavow6bnkxzhsvnzga3pmtfayvi"


const Key ="os_v2_app_fi7vjryhdzb2fpwwplmcjdpgoxqqdugjzxhe2pmsii3rlpt3r2vyexryrp5ypogdzvztdhquverp57fr2aw5cjfwjo2fzosvogf722y"

// const Key ="os_v2_app_r6efkxoplfcwjl5txoua4rz4ztc772qsvl2eqruhbpyohaokarhaw65r6jlok5az5vis7lju6abvkavow6bnkxzhsvnzga3pmtfayvi"

// Initialize OneSignal

export const initOneSignal = async () => {
  await OneSignal.init({ appId: IOS_APP_ID || '', allowLocalhostAsSecureOrigin: true });
  await OneSignal.init({ appId: ANDROID_APP_ID || '', allowLocalhostAsSecureOrigin: true });

  OneSignal.showSlidedownPrompt();
}


const sendToApp = async (appId, content, heading, recipients, sendTime,keyUse) => {
  const body = {
    app_id: appId,
    contents: { en: content },
    headings: { en: heading },
    included_segments: recipients.includes('All') ? ['All'] : undefined,
    include_player_ids: recipients.includes('All') ? undefined : recipients,
    send_after: sendTime ? new Date(sendTime * 1000).toISOString() : undefined,
  };

  const response = await fetch('https://onesignal.com/api/v1/notifications', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Basic ${keyUse}`,
    },
    body: JSON.stringify(body),
  });

  return await response.json();
};


export const sendNotification = async (content, heading, recipients = ['All'], sendTime = null) => {
  try {
    // const [androidResponse, iosResponse] = await Promise.all([
      sendToApp(IOS_APP_ID, content, heading, recipients, sendTime,KeyIos),
      sendToApp(ANDROID_APP_ID, content, heading, recipients, sendTime,Key)
    // ]);
    // return { android: androidResponse, ios: iosResponse };
  } catch (error) {
    console.error('Error sending notification to both platforms:', error);
    throw error;
  }
};


// Send a notification
// export const sendNotification = async (content, heading, recipients = ['All'], sendTime = null) => {
//     const body = {
//       app_id: IDApp,
//       contents: { en: content },
//       headings: { en: heading },
//       included_segments: recipients.includes('All') ? ['All'] : undefined,
//       include_player_ids: recipients.includes('All') ? undefined : recipients,
//       send_after: sendTime ? new Date(sendTime * 1000).toISOString() : undefined,
//     };
  
//     try {
//       const response = await fetch('https://onesignal.com/api/v1/notifications', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Basic ${Key}`, // Authorization header should include `Basic`
//         },
//         body: JSON.stringify(body),
//       });
//       return await response.json();
//     } catch (error) {
//       console.error('Error sending notification:', error);
//       throw error;
//     }
//   };


// Get notification history
export const getNotificationHistory = async () => {
    try {
      const response = await fetch(`https://onesignal.com/api/v1/notifications?app_id=${IDApp}`, {
        headers: {
          'Authorization': `Basic ${Key}`,
        },
      });
      return await response.json();
    } catch (error) {
      console.error('Error fetching notification history:', error);
      throw error;
    }
  }
  
  // Get user data
  export const getUserData = async () => {
    try {
      const response = await fetch(`https://onesignal.com/api/v1/players?app_id=${IDApp}`, {
        headers: {
          'Authorization': `Basic ${Key}`,
        },
      });
      return await response.json();
    } catch (error) {
      console.error('Error fetching user data:', error);
      throw error;
    }
  }
  
  // Get analytics data
  export const getAnalyticsData = async (startDate, endDate) => {
    try {
      const response = await fetch(`https://onesignal.com/api/v1/apps/${IDApp}/deliveries?start=${startDate}&end=${endDate}`, {
        headers: {
          'Authorization': `Basic ${Key}`,
        },
      });
      return await response.json();
    } catch (error) {
      console.error('Error fetching analytics data:', error);
      throw error;
    }
  }